"use client";
import { j as c } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as S } from "./tv.config-BuYIgndg.mjs";
import * as r from "react";
import { u as g } from "./useRenderElement-B8V3_e8R.mjs";
import { u as h } from "./useEventCallback-CjuAhyNz.mjs";
import { u as y } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { N as w } from "./noop-CMWc2wUO.mjs";
import { u as C } from "./useTimeout-BRUciAq6.mjs";
const p = /* @__PURE__ */ r.createContext(void 0);
process.env.NODE_ENV !== "production" && (p.displayName = "AvatarRootContext");
function A() {
  const s = r.useContext(p);
  if (s === void 0)
    throw new Error("Base UI: AvatarRootContext is missing. Avatar parts must be placed within <Avatar.Root>.");
  return s;
}
const v = {
  imageLoadingStatus: () => null
}, b = /* @__PURE__ */ r.forwardRef(function(e, n) {
  const {
    className: d,
    render: o,
    ...t
  } = e, [a, u] = r.useState("idle"), l = r.useMemo(() => ({
    imageLoadingStatus: a
  }), [a]), m = r.useMemo(() => ({
    imageLoadingStatus: a,
    setImageLoadingStatus: u
  }), [a, u]), i = g("span", e, {
    state: l,
    ref: n,
    props: t,
    customStyleHookMapping: v
  });
  return /* @__PURE__ */ c.jsx(p.Provider, {
    value: m,
    children: i
  });
});
process.env.NODE_ENV !== "production" && (b.displayName = "AvatarRoot");
function I(s, {
  referrerPolicy: e,
  crossOrigin: n
}) {
  const [d, o] = r.useState("idle");
  return y(() => {
    if (!s)
      return o("error"), w;
    let t = !0;
    const a = new window.Image(), u = (l) => () => {
      t && o(l);
    };
    return o("loading"), a.onload = u("loaded"), a.onerror = u("error"), e && (a.referrerPolicy = e), a.crossOrigin = n ?? null, a.src = s, () => {
      t = !1;
    };
  }, [s, n, e]), d;
}
const E = /* @__PURE__ */ r.forwardRef(function(e, n) {
  const {
    className: d,
    render: o,
    onLoadingStatusChange: t,
    referrerPolicy: a,
    crossOrigin: u,
    ...l
  } = e, m = A(), i = I(e.src, {
    referrerPolicy: a,
    crossOrigin: u
  }), f = h((N) => {
    t == null || t(N), m.setImageLoadingStatus(N);
  });
  y(() => {
    i !== "idle" && f(i);
  }, [i, f]);
  const x = r.useMemo(() => ({
    imageLoadingStatus: i
  }), [i]);
  return g("img", e, {
    state: x,
    ref: n,
    props: l,
    customStyleHookMapping: v,
    enabled: i === "loaded"
  });
});
process.env.NODE_ENV !== "production" && (E.displayName = "AvatarImage");
const R = /* @__PURE__ */ r.forwardRef(function(e, n) {
  const {
    className: d,
    render: o,
    delay: t,
    ...a
  } = e, {
    imageLoadingStatus: u
  } = A(), [l, m] = r.useState(t === void 0), i = C();
  r.useEffect(() => (t !== void 0 && i.start(t, () => m(!0)), i.clear), [i, t]);
  const f = r.useMemo(() => ({
    imageLoadingStatus: u
  }), [u]);
  return g("span", e, {
    state: f,
    ref: n,
    props: a,
    customStyleHookMapping: v,
    enabled: u !== "loaded" && l
  });
});
process.env.NODE_ENV !== "production" && (R.displayName = "AvatarFallback");
const j = S({
  base: [
    "Avatar__root",
    "inline-flex",
    "items-center",
    "justify-center",
    "overflow-hidden",
    "rounded-full",
    "bg-gray-100",
    "align-middle",
    "text-base",
    "font-medium",
    "text-black",
    "select-none"
  ],
  variants: {
    variant: {
      circle: ["rounded-full"],
      square: ["rounded-none"],
      rounded: ["rounded-md"]
    },
    size: {
      small: ["size-8"],
      medium: ["size-12"],
      large: ["size-14"]
    }
  }
}), L = S({
  base: ["Avatar__image size-full object-cover"],
  variants: {
    variant: {
      circle: ["rounded-full"],
      square: ["rounded-none"],
      rounded: ["rounded-2xl"]
    }
  }
}), k = (s) => {
  var d, o, t;
  const e = (d = s == null ? void 0 : s.toUpperCase()) == null ? void 0 : d.split(" ");
  let n = (o = e == null ? void 0 : e[0]) == null ? void 0 : o[0];
  return (t = e == null ? void 0 : e[1]) != null && t[0] && (n += e[1][0]), n;
};
function q(s) {
  const {
    children: e,
    size: n = "medium",
    src: d,
    alt: o,
    variant: t = "circle",
    className: a
  } = s;
  return /* @__PURE__ */ c.jsxs(
    b,
    {
      className: j({
        className: a,
        variant: t,
        size: n
      }),
      children: [
        d && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
          /* @__PURE__ */ c.jsx(
            E,
            {
              src: d,
              width: "48",
              height: "48",
              alt: o,
              className: L({})
            }
          ),
          /* @__PURE__ */ c.jsx(R, { className: "flex size-full items-center justify-center text-base", children: o ? k(o) : e })
        ] }),
        e
      ]
    }
  );
}
export {
  q as default
};
